class CheckoutService {
    constructor() {
        this.checkoutForm = document.querySelector("form.checkout");

        if (!this.checkoutForm) return;

        this.moveFieldErrors();

        new MutationObserver(() => this.moveFieldErrors()).observe(this.checkoutForm, {
            childList: true,
            subtree: true,
        });

        ["input", "change"].forEach((eventName) => {
            this.checkoutForm.addEventListener(eventName, (event) => {
                const formRow = event.target.closest(".form-row");
                if (formRow) {
                    this.removeInlineError(formRow);
                }
            });
        });
    }

    moveFieldErrors() {
        const labels = window.PayPalCommerceGateway?.labels;
        if (!labels) return;

        const errorTargets = this.getErrorTargets(labels);

        this.checkoutForm.querySelectorAll(":scope > ul.woocommerce-error").forEach((notice) => {
            Array.from(notice.children).forEach((errorItem) => {
                const message = errorItem.textContent.trim();
                const formRow = errorTargets.get(message);

                if (!formRow) return;

                this.showInlineError(formRow, message);
                errorItem.remove();
            });

            if (!notice.children.length) {
                notice.remove();
            }
        });
    }

    getErrorTargets(labels) {
        const targets = new Map();
        const billingFields = this.checkoutForm.querySelector(".woocommerce-billing-fields");
        const shippingFields = this.checkoutForm.querySelector(".woocommerce-shipping-fields");

        this.checkoutForm
            .querySelectorAll(".validate-required.woocommerce-invalid")
            .forEach((formRow) => {
                const field = formRow.querySelector("[name]");
                if (!field) return;

                const customMessage = labels.error?.required?.elements?.[field.name];
                if (customMessage) {
                    targets.set(this.toText(customMessage), formRow);
                    return;
                }

                let fieldLabel = formRow.querySelector("label")?.textContent.replaceAll("*", "").trim();
                if (!fieldLabel) return;

                if (billingFields?.contains(formRow)) {
                    fieldLabel = labels.billing_field.replace("%s", fieldLabel);
                } else if (shippingFields?.contains(formRow)) {
                    fieldLabel = labels.shipping_field.replace("%s", fieldLabel);
                }

                const message = labels.error?.required?.field?.replace("%s", fieldLabel);
                if (message) {
                    targets.set(this.toText(message), formRow);
                }
            });

        return targets;
    }

    showInlineError(formRow, message) {
        const field = formRow.querySelector("[name]");
        if (!field) return;

        this.removeInlineError(formRow);

        const fieldId = field.id || field.name.replace(/[^a-zA-Z0-9_-]/g, "_");
        const errorMessage = document.createElement("p");
        errorMessage.id = `${fieldId}_description`;
        errorMessage.className = "checkout-inline-error-message";
        errorMessage.dataset.kdPaypalError = "true";
        errorMessage.textContent = message;
        formRow.append(errorMessage);

        formRow.classList.add("woocommerce-invalid", "woocommerce-invalid-required-field");
        field.setAttribute("aria-describedby", errorMessage.id);
        field.setAttribute("aria-invalid", "true");
    }

    removeInlineError(formRow) {
        const field = formRow.querySelector("[name]");
        formRow.querySelector('[data-kd-paypal-error="true"]')?.remove();

        if (field) {
            field.removeAttribute("aria-describedby");
            field.removeAttribute("aria-invalid");
        }
    }

    toText(html) {
        const element = document.createElement("div");
        element.innerHTML = html;
        return element.textContent.trim();
    }
}

export default CheckoutService;
